import { precompileTemplate } from "@ember/template-compilation";
export default precompileTemplate("",{ moduleName: "dac-error-budget/components/adi-generic.hbs" })